
export default function AboutSection() {
  const features = [
    {
      icon: 'ri-code-s-slash-line',
      title: 'Desenvolvimento de Software',
      description: 'Criamos aplicações web e mobile personalizadas com as mais modernas tecnologias do mercado.',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: 'ri-cloud-line',
      title: 'Soluções em Nuvem',
      description: 'Migração e implementação de sistemas em nuvem para maior escalabilidade e segurança.',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Segurança Digital',
      description: 'Implementamos as melhores práticas de segurança para proteger seus dados e sistemas.',
      color: 'from-green-500 to-teal-500'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Transformação Digital',
      description: 'Ajudamos empresas a se adaptarem ao mundo digital com estratégias inovadoras.',
      color: 'from-orange-500 to-red-500'
    }
  ];

  return (
    <section id="sobre" className="py-20 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 to-slate-800"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-20 right-20 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-20 w-48 h-48 bg-purple-500/10 rounded-full blur-2xl"></div>

      <div className="relative z-10 container mx-auto px-6">
        {/* Section header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full text-blue-300 text-sm font-medium mb-6">
            <i className="ri-information-line mr-2"></i>
            Sobre a MPG System
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Especialistas em <span className="gradient-text-primary">Tecnologia</span>
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed">
            Somos uma empresa de <strong className="text-blue-300">desenvolvimento de software</strong> especializada em criar 
            <strong className="text-cyan-300"> soluções tecnológicas inovadoras</strong> que impulsionam o crescimento dos nossos clientes em todo o Brasil.
          </p>
        </div>

        {/* Main content */}
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Left content */}
          <div className="space-y-8">
            <div className="glass-card p-8 rounded-2xl">
              <h3 className="text-2xl font-bold text-white mb-4">Nossa Missão</h3>
              <p className="text-white/80 leading-relaxed mb-6">
                Transformar ideias em <strong className="text-blue-300">soluções digitais eficientes</strong>, 
                oferecendo <strong className="text-purple-300">desenvolvimento de software de alta qualidade </strong> 
                e <strong className="text-cyan-300">consultoria especializada em TI</strong> para empresas de todos os segmentos e portes.
              </p>
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center">
                  <i className="ri-target-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-white font-semibold">Foco no Cliente</div>
                  <div className="text-white/60 text-sm">Soluções personalizadas para cada necessidade</div>
                </div>
              </div>
            </div>

            <div className="glass-card p-8 rounded-2xl">
              <h3 className="text-2xl font-bold text-white mb-4">Nossa Visão</h3>
              <p className="text-white/80 leading-relaxed mb-6">
                Ser referência em <strong className="text-blue-300">transformação digital</strong> no mercado brasileiro, 
                conectando empresas ao futuro através de <strong className="text-purple-300">tecnologias inovadoras</strong> 
                e <strong className="text-cyan-300">soluções inteligentes</strong>.
              </p>
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-600 rounded-xl flex items-center justify-center">
                  <i className="ri-eye-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-white font-semibold">Inovação Constante</div>
                  <div className="text-white/60 text-sm">Sempre à frente das tendências tecnológicas</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right content - Image */}
          <div className="relative">
            <div className="glass-card p-8 rounded-2xl">
              <img 
                src="https://static.readdy.ai/image/a74dd7e7f2d6adb4e533c9016359af25/86e0f47172eff7aa1c2014c65e3b895a.jpeg"
                alt="Equipe de desenvolvimento MPG System"
                className="w-full h-80 object-cover rounded-xl"
              />
              <div className="mt-6 grid grid-cols-3 gap-4 text-center">
                <div>
                  <div className="text-2xl font-bold text-white">5+</div>
                  <div className="text-blue-300 text-sm">Anos no Mercado</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-white">50+</div>
                  <div className="text-purple-300 text-sm">Projetos Concluídos</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-white">100%</div>
                  <div className="text-cyan-300 text-sm">Comprometimento</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Features grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="glass-card p-6 rounded-2xl card-hover group"
            >
              <div className={`w-12 h-12 bg-gradient-to-r ${feature.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-white text-xl`}></i>
              </div>
              <h4 className="text-lg font-semibold text-white mb-3">{feature.title}</h4>
              <p className="text-white/70 text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Call to action */}
        <div className="text-center mt-16">
          <div className="glass-card p-8 rounded-2xl max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-4">
              Pronto para Transformar sua Empresa?
            </h3>
            <p className="text-white/80 mb-6">
              Entre em contato conosco e descubra como podemos ajudar sua empresa a crescer com 
              <strong className="text-blue-300"> soluções tecnológicas personalizadas</strong>.
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('contato');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="btn-primary"
            >
              <i className="ri-phone-line mr-2"></i>
              Falar com Especialista
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
